import { SessionStorageKey } from "@components/refactored-survey/question-sets/insurance-survey-questions/utils/SessionStorageKey";

// This is `true` for users that are scheduling their first consult.
export const getIsNewPatient = (): boolean =>
  sessionStorage.getItem(SessionStorageKey.isNewPatient) === true.toString();

export const setIsNewPatient = (value: boolean) =>
  sessionStorage.setItem(SessionStorageKey.isNewPatient, value.toString());
